import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";

const RoundedRectangle = ({ width, height1, height2, colors }) => {
  const controls = useAnimation();

  useEffect(() => {
    const animateHeight = () => {
      controls.start({
        height: [height1, height2, height1],
        backgroundColor: colors.active
          ? [colors.default, colors.active, colors.default]
          : colors.default,
        transition: { duration: 3, repeat: Infinity, ease: "easeInOut" },
      });
    };

    setTimeout(animateHeight, 2000);
  }, [controls, height1, height2, colors]);

  return (
    <motion.div
      className="bg-gray-500 rounded-lg"
      style={{
        width,
        height: height1,
        backgroundColor: colors.default,
        borderRadius: "42.646px",
      }}
      animate={controls}
    />
  );
};

export default RoundedRectangle;
